import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AboutPage from "./components/Aboutpage/AboutPage";
import ContactPage from "./components/Contact/ContactPage";
import HomePage from "./components/HomePage";
import BlogPage from "./components/Blogpage/BlogPage";
import ServicesPage from "./components/Servicespage/ServicesPage";
import Blog from "./components/Blogpage/Blog";
import AddBlog from './components/Blogpage/AddBlog';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/About" element={<AboutPage />} />
        <Route path="/Contact" element={<ContactPage />} />
        <Route path="/Blogs" element={<BlogPage />} />
        <Route path="/blogs/:id" element={<Blog />} />
        <Route path="/addBlog" element={<AddBlog />} />
        <Route path="/Services" element={<ServicesPage />} />
      </Routes>
    </Router>
  );
}

export default App;